import { Component, EventEmitter, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-confirm',
  templateUrl: './dialog-confirm.component.html',
  styleUrls: ['./dialog-confirm.component.scss']
})
export class DialogConfirmComponent {

  dataList: string[] = [];

  confirm: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly dialogRef: MatDialogRef<DialogConfirmComponent>) {
    this.dataList = this.data?.list;
  }

  confirmAction(): void {
    this.confirm.emit(true);
    this.dialogRef.close(true);
  }

  deniedAction(): void {
    this.confirm.emit(false);
    this.dialogRef.close(false);
  }

}
